// Import general mixin for shared functionality.
import { setCookie, getCookie, deleteCookie } from '../functions.js';
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import listItem from './components/ListItem.vue';
import LeafletMap from './components/LeafletMap.vue';

const projectsApp = {
    ...defaultApp,
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        ...defaultApp.components,
        listItem,
        LeafletMap
    },
    data() {
        return {
            ...defaultApp.data(),
            mapView: false,
        }
    },
    watch: {
        async mapView(newView) {
            if (newView) {
                setCookie(this.constants.cookies.mapView, 'true', 365);
            } else {
                deleteCookie(this.constants.cookies.mapView);
            }

            this.dataLimit = newView ? 9999 : (this.$el.dataset.limit ? parseInt(this.$el.dataset.limit*this.page) : 15);
            this.data.items = [];
            const response = await this.fetchData();
            this.setData(response, true);
        }
    },
    created() {
        // Check which view is set as cookie.
        if (getCookie(this.constants.cookies.mapView) !== '') this.mapView = true;
        this.dataLimit = this.mapView ? 9999 : null;
        // Initialize the debounced loading function.
        this.debounceSetLoading = this.createDebouncedLoading();
    },
};

export default projectsApp;
